import { takeLatest, all, put, fork, call } from 'redux-saga/effects'
import { push } from 'connected-react-router'

import * as actions from '../../actions/actions'

import { corporate, putCorporate } from '../../../api/corporateApi'
import {hasBankAuthorizer} from "../../../api/userApi";

export default function* corporateEditSaga() {
  yield all([
    fork(watchFetchCorporateEditRequest),
    fork(watchUpdateCorporateEditRequestRequest),
    fork(watchEditCorporateIdBankFieldChangeRequest),
    fork(watchEditCorporateCorporateSenderIdFieldChangeRequest),
    fork(watchEditCorporateCorporateAutoAcceptFieldChangeRequest),
    fork(watchEditCorporateCorporateTimeToExpireFieldChangeRequest),
    fork(watchEditCorporateCorporateWhatsappFieldChangeRequest),
    fork(watchEditCorporateCorporateDaysToFirstReminderFieldChangeRequest),
    fork(watchEditCorporateCorporateDaysToSecondReminderFieldChangeRequest),
    fork(watchEditCorporateCorporateSenderNameFieldChangeRequest),
    fork(watchEditCorporateEnabledFieldChangeRequest),
    fork(watchEditCorporateCleanRequest),
    fork(watchEditCorporatePrimaryColorChangeRequest),
    fork(watchEditCorporateSecondaryColorChangeRequest),
    fork(watchEditCorporateLogoChangeRequest),
    fork(watchEditCorporateCorporateHasBankAuthorizerChangeRequest),
    fork(watchEditCorporateCorporateHasBankAuthorizerExistsRequest),
  ]);
}

function* watchEditCorporateLogoChangeRequest() {
  yield takeLatest(
    actions.EDIT_CORPORATE_CORPORATE_LOGO_FILED_CHANGE_REQUEST,
    editCorporateLogoChangeRequest
  )
}

function* editCorporateLogoChangeRequest(logo) {
  yield put({ type: actions.EDIT_CORPORATE_CORPORATE_LOGO_FILED_CHANGE, value: logo.value })
}

function* watchFetchCorporateEditRequest() {
  yield takeLatest(
    actions.FETCH_CORPORATE_EDIT_REQUEST,
    fetchCorporateEditRequest
  )
}

function* fetchCorporateEditRequest(corporateData) {
  yield put({ type: actions.PROGRESS_START_REQUEST })
  try {
    let { data } = yield call(corporate,corporateData.value.bankId, corporateData.value.corporate)
    yield put({ type: actions.EDIT_CORPORATE_CLEAN })

    yield put({ type: actions.FETCH_CORPORATE_EDIT_SUCCESS, value: data })
    // yield put({ type: actions.UPDATE_CORPORATE_EDIT_BANK_ID, value: corporateData.value.bankId })
    yield put(push(`/corporate/edit/${corporateData.value.corporate}`))
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
  } catch (error) {
    if(error.response){
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.FETCH_CORPORATE_EDIT_FAILURE, error: error.response })
      yield put({ type: actions.FETCH_ERROR_REQUEST_SERVER, error: error.response })
    }else if(error.request)
    {
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.FETCH_ERROR_REQUEST_CLIENT, error: error.response })
    }
  }
}

function* watchUpdateCorporateEditRequestRequest() {
  yield takeLatest(
    actions.UPDATE_CORPORATE_EDIT_REQUEST,
    updateCorporateEditRequestRequest
  )
}

function* updateCorporateEditRequestRequest(corporateData) {
  yield put({type: actions.CLEAN_ERROR})
  yield put({ type: actions.PROGRESS_START_REQUEST })
  try {
    let { data } = yield call(putCorporate,corporateData.value.bank, corporateData.value)
    yield put({ type: actions.UPDATE_CORPORATE_EDIT_SUCCESS, value: data })
    yield put({type:actions.AUTHENTICATED_CORPORATE_USER_LOGO_UPDATE,value: corporateData.value.logo})
    yield put({type:actions.AUTHENTICATED_CORPORATE_PRIMARY_COLOR_CHANGE,value:corporateData.value.primaryColor})
    yield put({type:actions.AUTHENTICATED_CORPORATE_SECONDARY_COLOR_CHANGE,value:corporateData.value.secondaryColor})
    yield put(push(`/corporate`))
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
    yield put({ type: actions.EDIT_CORPORATE_CLEAN_REQUEST })
  } catch (error) {
    if(error.response){
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.UPDATE_CORPORATE_EDIT_FAILURE, error: error.response })
      yield put({ type: actions.FETCH_ERROR_REQUEST_SERVER, error: error.response })
    }else if(error.request)
    {
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.FETCH_ERROR_REQUEST_CLIENT, error: error.response })
    }
  }
}

function* watchEditCorporateIdBankFieldChangeRequest() {
  yield takeLatest(
    actions.EDIT_CORPORATE_ID_BANK_FIELD_CHANGE_REQUEST,
    editCorporateIdBankFieldChangeRequest
  )
}

function* editCorporateIdBankFieldChangeRequest(corporateIdBank) {
  if(corporateIdBank.value !== null)
    yield put({ type: actions.EDIT_CORPORATE_ID_BANK_FIELD_CHANGE, value: corporateIdBank.value })
  else
    yield put({ type: actions.EDIT_CORPORATE_ID_BANK_FIELD_CHANGE, value: '' })
}

function* watchEditCorporateCorporateSenderIdFieldChangeRequest() {
  yield takeLatest(
    actions.EDIT_CORPORATE_CORPORATE_SENDER_ID_FIELD_CHANGE_REQUEST,
    editCorporateCorporateSenderIdFieldChangeRequest
  )
}

function* editCorporateCorporateSenderIdFieldChangeRequest(corporateSenderId) {
  yield put({ type: actions.EDIT_CORPORATE_CORPORATE_SENDER_ID_FIELD_CHANGE, value: corporateSenderId.value })
}

function* watchEditCorporateCorporateWhatsappFieldChangeRequest() {
  yield takeLatest(
      actions.EDIT_CORPORATE_CORPORATE_WHATSAPP_FIELD_CHANGE_REQUEST,
      editCorporateCorporateWhatsappFieldChangeRequest
  )
}

function* editCorporateCorporateWhatsappFieldChangeRequest(whatsapp) {
  if(whatsapp.value !== null)
    yield put({type: actions.EDIT_CORPORATE_CORPORATE_WHATSAPP_FIELD_CHANGE, value: whatsapp.value})
  else
    yield put({type: actions.EDIT_CORPORATE_CORPORATE_WHATSAPP_FIELD_CHANGE, value: ''})
}

function* watchEditCorporateCorporateDaysToFirstReminderFieldChangeRequest() {
  yield takeLatest(
      actions.EDIT_CORPORATE_CORPORATE_DAYS_TO_FIRST_REMINDER_FIELD_CHANGE_REQUEST,
      editCorporateCorporateDaysToFirstReminderFieldChangeRequest
  )
}

function* editCorporateCorporateDaysToFirstReminderFieldChangeRequest(daysToFirstReminder) {
  yield put({ type: actions.EDIT_CORPORATE_CORPORATE_DAYS_TO_FIRST_REMINDER_FIELD_CHANGE, value: daysToFirstReminder.value })
}
function* watchEditCorporateCorporateDaysToSecondReminderFieldChangeRequest() {
  yield takeLatest(
      actions.EDIT_CORPORATE_CORPORATE_DAYS_TO_SECOND_REMINDER_FIELD_CHANGE_REQUEST,
      editCorporateCorporateDaysToSecondReminderFieldChangeRequest
  )
}

function* editCorporateCorporateDaysToSecondReminderFieldChangeRequest(daysToSecondReminder) {
  yield put({ type: actions.EDIT_CORPORATE_CORPORATE_DAYS_TO_SECOND_REMINDER_FIELD_CHANGE, value: daysToSecondReminder.value })
}

function* watchEditCorporateCorporateAutoAcceptFieldChangeRequest() {
  yield takeLatest(
      actions.EDIT_CORPORATE_CORPORATE_AUTOACCEPT_FIELD_CHANGE_REQUEST,
      editCorporateCorporateAutoAcceptFieldChangeRequest
  )
}

function* editCorporateCorporateAutoAcceptFieldChangeRequest(autoAccept) {
  if(autoAccept.value !== null)
    yield put({type: actions.EDIT_CORPORATE_CORPORATE_AUTOACCEPT_FIELD_CHANGE, value: autoAccept.value})
  else
    yield put({type: actions.EDIT_CORPORATE_CORPORATE_AUTOACCEPT_FIELD_CHANGE, value: ''})
}

function* watchEditCorporateCorporateTimeToExpireFieldChangeRequest() {
  yield takeLatest(
      actions.EDIT_CORPORATE_CORPORATE_TIME_TO_EXPIRE_FIELD_CHANGE_REQUEST,
      editCorporateCorporateTimeToExpireFieldChangeRequest
  )
}

function* editCorporateCorporateTimeToExpireFieldChangeRequest(timeToExpire) {
  yield put({ type: actions.EDIT_CORPORATE_CORPORATE_TIME_TO_EXPIRE_FIELD_CHANGE, value: timeToExpire.value })
}

function* watchEditCorporateCorporateSenderNameFieldChangeRequest() {
  yield takeLatest(
    actions.EDIT_CORPORATE_CORPORATE_SENDER_NAME_FIELD_CHANGE_REQUEST,
    editCorporateCorporateSenderNameFieldChangeRequest
  )
}

function* editCorporateCorporateSenderNameFieldChangeRequest(corporateSenderName) {
  yield put({ type: actions.EDIT_CORPORATE_CORPORATE_SENDER_NAME_FIELD_CHANGE, value: corporateSenderName.value })
}

function* watchEditCorporateEnabledFieldChangeRequest() {
  yield takeLatest(
    actions.EDIT_CORPORATE_ENABLED_FILED_CHANGE_REQUEST,
    editCorporateEnabledFieldChangeRequest
  )
}

function* editCorporateEnabledFieldChangeRequest(enabled) {
  yield put({ type: actions.EDIT_CORPORATE_ENABLED_FILED_CHANGE, value: enabled.value })
}

function* watchEditCorporateCleanRequest() {
  yield takeLatest(
    actions.EDIT_CORPORATE_CLEAN_REQUEST,
    editCorporateCleanRequest
  )
}

function* editCorporateCleanRequest() {
  yield put({ type: actions.EDIT_CORPORATE_CLEAN })
}

function* watchEditCorporatePrimaryColorChangeRequest() {
  yield takeLatest(
    actions.CORPORATE_PRIMARY_COLOR_CHANGE_REQUEST,
    editCorporatePrimaryColorChangeRequest
  )
}

function* editCorporatePrimaryColorChangeRequest(value) {
  yield put({ type: actions.CORPORATE_PRIMARY_COLOR_CHANGE, value: value.value })
}

function* watchEditCorporateSecondaryColorChangeRequest() {
  yield takeLatest(
    actions.CORPORATE_SECONDARY_COLOR_CHANGE_REQUEST,
    editCorporateSecondaryColorChangeRequest
  )
}

function* editCorporateSecondaryColorChangeRequest(value) {
  yield put({ type: actions.CORPORATE_SECONDARY_COLOR_CHANGE, value: value.value })
}


function* watchEditCorporateCorporateHasBankAuthorizerChangeRequest() {

  yield takeLatest(
      actions.EDIT_CORPORATE_CORPORATE_HAS_BANK_AUTHORIZER_CHANGE_REQUEST,
      editCorporateCorporateHasBankAuthorizerChangeRequest
  )
}

function* editCorporateCorporateHasBankAuthorizerChangeRequest(value) {

  if(value.value===true){

    yield put({ type: actions.EDIT_CORPORATE_CORPORATE_HAS_BANK_AUTHORIZER_ENABLE_CHANGE, value: value.value })

  }else if(value.value===false){

    yield put({ type: actions.EDIT_CORPORATE_CORPORATE_HAS_BANK_AUTHORIZER_DISABLE_CHANGE, value: value.value })
  }

}

function* watchEditCorporateCorporateHasBankAuthorizerExistsRequest() {
  yield takeLatest(
      actions.EDIT_CORPORATE_CORPORATE_HAS_BANK_AUTHORIZER_EXISTS_REQUEST,
      editCorporateCorporateHasBankAuthorizerExistsRequest
  )
}

function* editCorporateCorporateHasBankAuthorizerExistsRequest(bankId) {
  yield put({type: actions.CLEAN_ERROR})
  yield put({ type: actions.PROGRESS_START_REQUEST })
  try {
    let { data } = yield call(hasBankAuthorizer, bankId.value)
    if(data===false){
      yield put({ type: actions.EDIT_CORPORATE_CORPORATE_HAS_BANK_AUTHORIZER_EXISTS,value:true})
    }else if(data===true){
      yield put({ type: actions.EDIT_CORPORATE_CORPORATE_HAS_BANK_AUTHORIZER_EXISTS,value:false})
    }


    // yield put({ type: actions.SAVE_CORPORATE_CREATE_SUCCESS, value: data })
    // yield put(push(`/corporate`))
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
    // yield put({ type: actions.CREATE_CORPORATE_CLEAN_REQUEST })
  } catch (error) {
    if(error.response){
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.UPDATE_CORPORATE_EDIT_FAILURE, error: error.response })
      yield put({ type: actions.FETCH_ERROR_REQUEST_SERVER, error: error.response })
    }else if(error.request)
    {
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.FETCH_ERROR_REQUEST_CLIENT, error: error.response })
    }
  }
}
